var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2951_114)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 20.5,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 22C26.309 22 29 19.309 29 16C29 12.691 26.309 10 23 10C19.691 10 17 12.691 17 16C17 19.309 19.691 22 23 22ZM23 11C25.757 11 28 13.243 28 16C28 18.757 25.757 21 23 21C20.243 21 18 18.757 18 16C18 13.243 20.243 11 23 11ZM35.5 21H29.5C28.121 21 27 22.122 27 23.5V31.5C27 32.878 28.121 34 29.5 34H35.5C36.879 34 38 32.878 38 31.5V23.5C38 22.122 36.879 21 35.5 21ZM37 31.5C37 32.327 36.327 33 35.5 33H29.5C28.673 33 28 32.327 28 31.5V23.5C28 22.673 28.673 22 29.5 22H35.5C36.327 22 37 22.673 37 23.5V31.5ZM35 24.497C35 24.773 34.776 24.997 34.5 24.997H30.5C30.224 24.997 30 24.773 30 24.497C30 24.221 30.224 23.997 30.5 23.997H34.5C34.776 23.997 35 24.221 35 24.497ZM35 27.5C35 27.776 34.776 28 34.5 28H30.5C30.224 28 30 27.776 30 27.5C30 27.224 30.224 27 30.5 27H34.5C34.776 27 35 27.224 35 27.5ZM35 30.497C35 30.773 34.776 30.997 34.5 30.997H30.5C30.224 30.997 30 30.773 30 30.497C30 30.221 30.224 29.997 30.5 29.997H34.5C34.776 29.997 35 30.221 35 30.497ZM24.992 24.719C24.943 24.991 24.681 25.172 24.413 25.124C23.948 25.042 23.473 25 23 25C18.589 25 15 28.589 15 33V33.5C15 33.776 14.776 34 14.5 34C14.224 34 14 33.776 14 33.5V33C14 28.038 18.037 24 23 24C23.531 24 24.065 24.047 24.587 24.14C24.859 24.188 25.041 24.448 24.992 24.72V24.719Z",
    fill: "#6A7988",
    stroke: "#6A7988",
    strokeWidth: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2951_114",
    x: 0,
    y: 0,
    width: 49,
    height: 49,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.468733 0 0 0 0 0.51145 0 0 0 0 0.554167 0 0 0 0.39 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2951_114"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2951_114",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalUsers);
export default __webpack_public_path__ + "static/media/total-users.dc1c4a6376eb8847cd1291b694305936.svg";
export { ForwardRef as ReactComponent };